module.exports = __webpack_public_path__ + "img/3_b.13666d78.jpg";